import React, { useState, useMemo, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MaterialReactTable from 'material-react-table';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import AddIcon from "@mui/icons-material/Add";
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const checkedIcon = <CheckBoxIcon fontSize="small" />;
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
import RefreshIcon from '@mui/icons-material/Refresh';
import LockResetIcon from '@mui/icons-material/LockReset';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Divider from '@mui/material/Divider';
import { Tooltip } from "@mui/material";
import { logout } from "actions/auth";
import TextField from '@mui/material/TextField';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Dialog, DialogActions, DialogContent, DialogTitle, Select, DialogContentText } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
const { primary, secondary, text, tableRow, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}


import { getMonitorUserListByCustomerId, updateMonitoringUserByCustomerId, deleteMonitoringUserByCustomerId, getUserRoles, getCustomers, } from "apis/CustomersApis";
import { removeAllSpaces, toPascalCase } from "common_utils/utils";
import MonitorUserResetPassword from './MonitorUserResetPassword';
import MonitorUserTableDialog from './MonitorUserTableDialog';
import PhoneInput from "react-phone-input-2";


export default function UserManagement() {
    const columns = useMemo(
        () => [

            {
                header: 'Email',
                accessorKey: 'email',
                filter: 'equals',
                id: 'email',
                size: 150,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={emailOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Email" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'emailFilterFn',

            },
            {
                accessorKey: 'role_name',
                header: 'Role Name',
                size: 120,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={roleNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option} </MenuItem>
                        )}
                        style={{ width: 140 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Role" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5, } }}
                    />
                ),
                filterFn: 'roleNameFilterFn',

            },
            {
                accessorKey: 'mosaic_view_enabled',
                header: 'Mosaic View',
                size: 100,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return (
                        <span
                            style={{
                                color: value ? secondary.main : text.disabled,
                            }}
                        >
                            {value ? 'Enabled' : 'Disabled'}
                        </span>
                    );
                }
            },
            {
                accessorKey: 'iomatrix_switch_enabled',
                header: 'Preset Switch',
                size: 100,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return (
                        <span
                            style={{
                                color: value ? secondary.main : text.disabled,
                            }}
                        >
                            {value ? 'Enabled' : 'Disabled'}
                        </span>
                    );
                }
            },
            {
                accessorKey: 'first_name',
                header: 'First Name',
                size: 150,
                enableColumnFilter: true,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={firstNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="First Name" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'firstNameFilterFn',

            },
            {
                accessorKey: 'last_name',
                header: 'Last Name',
                size: 150,
                enableColumnFilter: false,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={lastNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Last Name" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'lastNameFilterFn',

            },
            {
                accessorKey: 'phone',
                header: 'Phone Number',
                size: 150,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? value : '-';
                },
                enableSorting: true
            },
            {
                accessorKey: 'last_access_time',
                header: 'Last Access Time',
                size: 150,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? new Date(value).toLocaleString() : '-';
                },
                enableSorting: true
            },
        ],
        [],
    );
    const MyStateRole = useSelector(state => state.role);
    const UserId = useSelector(state => state.userid);
    const RoleId = useSelector(state => state.roleId);
    const Token = useSelector(state => state.accessToken);
    const isAccounting = (MyStateRole === "accounting") ? true : false;
    const isSalesOperator = (MyStateRole === "salesoperator") ? true : false;
    const isSalesAdmin = (MyStateRole === "salesadmin") ? true : false;
    const isSupport = (MyStateRole === "support") ? true : false;
    const isDealerAdmin = (MyStateRole === "dealeradmin") ? true : false;
    const isDealerOperator = (MyStateRole === "dealeroperator") ? true : false;
    const UserFirstName = useSelector(state => state.firstName);
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const [monitorUserList, setMonitorUserList] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [openViewDialog, setOpenViewDialog] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [roleName, setRoleName] = useState('');
    const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
    const [openMonitorUserDialog, setOpenMonitorUserDialog] = useState(false);
    const [customerId, setCustomerId] = useState();
    const dispatch = useDispatch();
    const history = useHistory();
    const [emailOptions, setEmailOptions] = useState([]);
    const [firstNameOptions, setFirstNameOptions] = useState([]);
    const [lastNameOptions, setLastNameOptions] = useState([]);
    const [roleNameOptions, setRoleNameOptions] = useState([]);
    const [muiTableKey, setMuiTableKey] = useState(0);
    const initialUserInfo = { user_id: 0, customer_id: 0, role_id: 3, role_name: "operator", email: "", phone: "", first_name: "", last_name: "", mosaic_view_enabled: false, iomatrix_switch_enabled: false };
    const [userInfo, setUserInfo] = useState(initialUserInfo);
    const [usrFName, setUsrFName] = useState('');
    const [usrLName, setUsrLName] = useState('');
    const [compError, setError] = useState("");
    const [usrRoleId, setUsrRoleId] = useState(3);
    const [userPassword, setPassword] = useState('');
    const [usrEmail, setUsrEmail] = useState('');
    const [usrPhoneNumber, setUsrPhoneNumber] = useState(userInfo.phone);
    const [enableSaveBtn, setEnableSaveBtn] = useState(true);
    const [enabledMosaicView, setEnabledMosaicView] = useState(false);
    const [enabledIOMatrixSwitch, setEnabledIOMatrixSwitch] = useState(false);
    const [openResetPassword, setOpenChangePassword] = useState(false);
    const [inProcess, setInProcess] = useState(false);

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [deleteMessageConfirm, setDeleteMessageConfirm] = useState("");
    const [deleteMessageConfirmTitle, setDeleteMessageConfirmTitle] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteAlertMsg, setDeleteAlertMsg] = useState("");
    const [pageAlertType, setPageAlertType] = useState("error");
    const [alertState, setAlertState] = useState({ openAlert: false, alertSeverity: "error", alertMessage: "", vertical: 'bottom', horizontal: 'left' });
    const { openAlert, alertSeverity, alertMessage, vertical, horizontal } = alertState;
    const [custDataList, setCustDataList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({ customer_id: 0, org_name: "" });
    const [userRoleList, setUserRoleList] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [alluser, setAllUser] = useState([]);

    const getMonitorUsersByCustomerId = (customerId) => {
        // console.log("Token::", Token);
        // console.log("getMonitorUsersByCustomerId: customerId:", customerId);
        return new Promise(function (resolve, reject) {
            getMonitorUserListByCustomerId(customerId).then((response) => {
                // console.log("getMonitorUserListByCustomerId: ", response);
                setMonitorUserList(response);
                resolve(response);
            }).catch((error) => {
                setMonitorUserList([]);
                let errMessage = '';
                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const getCustomerData = () => {
        // console.log("Token::", Token);
        return new Promise(function (resolve, reject) {
            getCustomers().then((response) => {
                //setProcessing(false);
                // console.log("getCustomerData::",response);
                if (response.length !== 0) {
                    setCustDataList(response);
                    setSelectedCustomer(response[0]);
                    getMonitorUsersByCustomerId(response[0].customer_id);
                    resolve(response);
                } else {
                    setCustDataList([]);
                    setSelectedCustomer({ customer_id: 0, org_name: "" });
                    setMonitorUserList([]);
                }
                // setCustDataList(response);
                // setSelectedCustomer(response[0]);
                // getMonitorUsersByCustomerId(response[0].customer_id);
                // resolve(response);
            }).catch((error) => {
                //setProcessing(false);
                setCustDataList([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        // <Redirect from="/" to="/login" />
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const getUserRolesData = () => {
        return new Promise(function (resolve, reject) {
            getUserRoles().then((response) => {
                //   console.log("getUserRolesData: ", response);
                setUserRoleList(response);
                resolve(response);
            }).catch((error) => {
                setUserRoleList([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    useEffect(() => {
        getCustomerData();
        getUserRolesData();
    }, []);

    useEffect(() => {
        let userInfo = initialUserInfo;
        if (selectedCustomer.customer_id > 0) userInfo.customer_id = selectedCustomer.customer_id;
        setUserInfo(userInfo);
        setCustomerId(selectedCustomer.customer_id);
    }, [selectedCustomer]);

    useEffect(() => {
        if (Array.isArray(monitorUserList) && monitorUserList.length > 0) {
            prepareMonUserData(monitorUserList);
        }
    }, [monitorUserList]);

    useEffect(() => {
    }, [emailOptions, firstNameOptions, lastNameOptions, roleNameOptions]);


    useEffect(() => {
    }, [usrFName, usrEmail, usrLName, userInfo, userPassword, usrRoleId, enabledMosaicView]);


    useEffect(() => {
    }, [selectedUsers]);

    const prepareMonUserData = (data) => {

        let updtdEmailOptions = emailOptions;
        let updtdFNameOptions = firstNameOptions;
        let updtdLNameOptions = lastNameOptions;
        let updtdRoleNameOptions = roleNameOptions;

        data.map(row => {

            // Required Fields
            const isDuplicateEmail = updtdEmailOptions.includes(row.email);
            const isDuplicateRoleName = updtdRoleNameOptions.includes(row.role_name);
            if (!isDuplicateEmail) {
                updtdEmailOptions.push(row.email);
            }

            if (!isDuplicateRoleName) {
                updtdRoleNameOptions.push(row.role_name);
            }

            // Optional Fields
            if (row.first_name.trim().length > 0) {
                const isDuplicateFirstName = updtdFNameOptions.includes(row.first_name);
                if (!isDuplicateFirstName) {
                    updtdFNameOptions.push(String(row.first_name));
                }
            }

            if (row.last_name.trim().length > 0) {
                const isDuplicateLastName = updtdLNameOptions.includes(row.last_name);
                if (!isDuplicateLastName) {
                    updtdLNameOptions.push(String(row.last_name));
                }
            } else { updtdLNameOptions.push(""); }
        });
        setEmailOptions(updtdEmailOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setFirstNameOptions(updtdFNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setLastNameOptions(updtdLNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setRoleNameOptions(updtdRoleNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };

    const prepareUserInfo = (row) => {
        let newUserInfo = userInfo;
        newUserInfo.customer_id = selectedCustomer.customer_id;
        newUserInfo.user_id = row.user_id;
        newUserInfo.first_name = row.first_name;
        newUserInfo.last_name = row.last_name;
        newUserInfo.role_name = row.role_name;
        newUserInfo.role_id = row.role_id;
        newUserInfo.email = row.email;
        newUserInfo.phone = row.phone;
        newUserInfo.mosaic_view_enabled = row.mosaic_view_enabled;
        setUsrFName(row.first_name);
        setUsrLName(row.last_name);
        setRoleName(row.role_name);
        setUsrEmail(row.email);
        setUsrPhoneNumber(row.phone);
        setEnabledMosaicView(row.mosaic_view_enabled);
        setEnabledIOMatrixSwitch(row.iomatrix_switch_enabled);
        return newUserInfo;
    };

    const handleUpdateOpen = (row) => {
        let locUserInfo = prepareUserInfo(row);
        locUserInfo.customer_id = selectedCustomer.customer_id;
        setSelectedRow(row);
        setUserInfo(locUserInfo);
        setOpenDialog(true);
    };

    const handleViewMonUserDetail = (row) => {
        let newUserInfo = prepareUserInfo(row);
        setSelectedRow(row);
        setUserInfo(newUserInfo);
        setOpenViewDialog(true);
    };

    const handlePasswordOpenForm = (row) => {
        let newUserInfo = prepareUserInfo(row);
        setUserInfo(newUserInfo);
        setSelectedRow(row);
        setOpenChangePassword(true);
    };

    const handlePasswordCloseForm = () => {
        setOpenChangePassword(false);
        setSelectedRow(null);
        setUserInfo(initialUserInfo);
        setSelectedUsers([]);
    };

    const handleUpdateCloseDialog = () => {
        setOpenDialog(false);
        setSelectedRow(null);
        setUserInfo(initialUserInfo);
        resetMyFilters();
    };


    const handleCloseViewCustomerDialog = () => {
        setOpenViewDialog(false);
        setSelectedRow(null);
        setUserInfo(initialUserInfo);
    };

    const handleUpdateCloseConfirmation = () => {
        setOpenConfirmationDialog(false);
    };

    const handleUpdateOpenConfirmation = () => {
        setOpenConfirmationDialog(true);
    };

    const handleTxtFldChange = (event) => {
        setError(null);
        switch (event.target.name) {
            case 'usrEmail':
                let usrEmail = event.target.value;
                usrEmail = removeAllSpaces(usrEmail)
                setUsrEmail(usrEmail);
                userInfo.email = usrEmail;
                setUserInfo(userInfo);
                break;
            case 'usrFName':
                let usrFName = event.target.value;
                usrFName = removeAllSpaces(usrFName)
                setUsrFName(usrFName);
                userInfo.first_name = usrFName;
                setUserInfo(userInfo);
                break;
            case 'usrLName':
                let usrLName = event.target.value;
                usrLName = removeAllSpaces(usrLName);
                setUsrLName(usrLName);
                userInfo.last_name = usrLName;
                setUserInfo(userInfo);
                break;
            case 'usrRoleName':
                let roleName = event.target.value;
                const roleObj = userRoleList.find(obj => toPascalCase(obj.role) === toPascalCase(roleName));
                if (roleObj) {
                    setRoleName(roleName);
                    userInfo.role_name = roleName;
                    userInfo.role_id = roleObj.id;
                    setUserInfo(userInfo);
                }
                break;
            case 'chkUsrMosaicView':
                let isChecked = event.target.checked;
                setEnabledMosaicView(isChecked);
                userInfo.mosaic_view_enabled = isChecked;
                setUserInfo(userInfo);
                break;
            case 'chkUsrIOMatrixSwitch':
                let isIOMatrixSwitchChecked = event.target.checked;
                setEnabledIOMatrixSwitch(isIOMatrixSwitchChecked);
                userInfo.iomatrix_switch_enabled = isIOMatrixSwitchChecked;
                setUserInfo(userInfo);
                break;

            default:
                break;

        }
    };

    const handlePhoneChange = (value) => {

        if (!value || value.trim() === "") {
            setUsrPhoneNumber("");
            userInfo.phone = "";
            setUserInfo(userInfo);
            return;
        }


        let usrPhoneNumber = removeAllSpaces("+" + value);
        //console.log(usrPhoneNumber);
        setUsrPhoneNumber(usrPhoneNumber);
        userInfo.phone = usrPhoneNumber;
        setUserInfo(userInfo);
    };


    const handleAddUserOpenDialog = () => {
        setOpenAddUserDialog(true);
    };

    const handleAddUserCloseDialog = async () => {
        setOpenAddUserDialog(false);
        await getMonitorUsersByCustomerId(selectedCustomer.customer_id);
        resetMyFilters();
    };

    const handleSave = async () => {
        userInfo.customer_id = selectedCustomer.customer_id;
        if (userInfo.customer_id !== null && userInfo.customer_id > 0 &&
            userInfo.user_id !== null && userInfo.user_id > 0) {
            try {
                await updateMonitoringUserByCustomerId(userInfo);
                await getMonitorUsersByCustomerId(userInfo.customer_id);
            } catch (error) {
                console.error("Error updating product type:", error);
            }
        } else { console.log('handleSave : NOT Updated'); }
        handleUpdateCloseConfirmation();
        handleUpdateCloseDialog();
    };

    const handleDeleteRow = () => {
        let strMsg = "Are you sure you want to delete?";
        setDeleteMessageConfirm(strMsg);
        setDeleteMessageConfirmTitle("Delete selected");
        setConfirmDeleteOpen(true);
    };

    const deleteUsers = async (userList) => {
        let errorList = [];
        let deletedUsers = [];
        for (let idx = 0; idx < userList.length; idx++) {
            let userInfo = userList[idx];
            try {
                await deleteMonitoringUserByCustomerId(customerId, userInfo.user_id)
                    .then((result) => {
                        if (result.code != 200) {
                            console.log("Error ocurred : ", result);
                            userInfo['error_msg'] = JSON.stringify(result);
                            errorList.push(userInfo);
                        } else {
                            deletedUsers.push(userInfo);
                        }
                    })
                    .catch((error) => {
                        userInfo['error_msg'] = error;
                        errorList.push(userInfo);
                    });
            } catch (error) {
                userInfo['error_msg'] = error;
                errorList.push(userInfo);
            }
        };

        setShowDeleteAlert(true);
        if ((errorList.length > 0)) {
            console.error("Error: User List :", errorList);
            setPageAlertType("error");
            setDeleteAlertMsg(`Error: ${errorList.length} user(s) were not deleted`);
        } else {
            setPageAlertType("success");
            setDeleteAlertMsg(`Success : ${deletedUsers.length} user(s) were deleted`);
        }
    }

    const handleDeleteYes = async () => {
        setConfirmDeleteOpen(false);
        if (customerId && customerId > 0 && (selectedUsers.length > 0)) {
            let updatedData = selectedUsers.filter(v => parseInt(v.user_id) !== parseInt(UserId));
            await deleteUsers(updatedData);
            await getMonitorUsersByCustomerId(customerId);
        }
        resetMyFilters();
        setSelectedUsers([]);
    }

    const handleDeleteNo = () => {
        setSelectedUsers([]);
        setConfirmDeleteOpen(false);
    };

    const handleConfirmClose = () => {
        setConfirmDeleteOpen(false);
        setSelectedUsers([]);
    };

    const resetMyFilters = () => {
        setMuiTableKey(muiTableKey + 1);
    };


    const handleDeleteAlertClose = (event, reason) => {

        if (reason === 'clickaway') {
            return;
        }
        setAlertState({ ...alertState, openAlert: false });
        setShowDeleteAlert(false);

    }

    const handleCustomerChange = async (e) => {
        const selectedOrgName = e.target.value;
        const selectedCustomer = custDataList.find(customer => customer.org_name === selectedOrgName);

        if (selectedCustomer) {
            setSelectedCustomer(selectedCustomer);
            await getMonitorUsersByCustomerId(selectedCustomer.customer_id);
            // setIsEditMode(isSupport ? false : true);
        } else {
            console.log("Invalid customerId : ", selectedCustomer.customer_id);
        }

    };




    return (
        <>
            <Box sx={{ marginBottom: 2 }}>
                <Box sx={{ width: "50%", marginLeft: 2, marginBottom: 2, marginTop: 2, display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
                        Search Customer Name :
                    </Typography>
                    <Select
                        id="customerId"
                        name="customerId"
                        value={selectedCustomer != null ? selectedCustomer.org_name : ""}
                        onChange={handleCustomerChange}
                        displayEmpty
                        fullWidth
                        sx={{
                            '.MuiSelect-select': {
                                paddingTop: '8px !important',
                                paddingBottom: '8px !important',
                                minHeight: '35px !important',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '1em !important'
                            }
                        }}
                    >
                        {custDataList && custDataList.length > 0 &&
                            custDataList.map((customer) => (
                                <MenuItem key={customer.customer_id} value={customer.org_name}>
                                    {customer.org_name}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </Box>

                <Box sx={{
                    backgroundColor: primary.main,
                    padding: 2, borderRadius: 2,
                }}>
                    <Grid container direction="row" spacing={2} justifyContent="center" display="flex" mt={0}>
                        <Grid item xs={12}>
                            <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, ml: 0 }}>
                                Customer Name:&nbsp;{selectedCustomer ? (selectedCustomer.org_name !== null ? selectedCustomer.org_name : '') : ''}
                            </Typography>
                        </Grid>
                        {(<Grid item xs={12}>
                            <Button variant="contained" disabled={isSupport} sx={{ ml: 1 }} color="secondary" aria-label="Add New User" onClick={handleAddUserOpenDialog}
                                endIcon={isSupport ? "" : <AddIcon sx={{ backgroundColor: secondary.main }} size="small" />}>Add User
                            </Button>
                        </Grid>)}
                        <Grid item xs={12} sm={12} md={12}>
                            {(monitorUserList && monitorUserList.length > 0) ?
                                (<div>
                                    <MaterialReactTable
                                        key={muiTableKey}
                                        columns={columns}
                                        data={monitorUserList}

                                        muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
                                        muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main } }}
                                        muiTableBodyRowProps={({ row }) => ({
                                            hover: true,
                                            sx: {
                                                color: text.main,
                                                align: 'center',
                                                '&:nth-of-type(odd)': {
                                                    backgroundColor: tableRow.dark,
                                                    border: 0,
                                                },
                                                '&:nth-of-type(even)': {
                                                    background: tableRow.light,
                                                },
                                                // hide last border
                                                '&:last-child td, &:last-child th': {
                                                    border: 0,
                                                },
                                                '&:hover td': {
                                                    background: tableRow.hover,
                                                },
                                            },
                                        })}
                                        muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', padding: '8px' } }}
                                        muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
                                        muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
                                        muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
                                        muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
                                        muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main, '& .MuiTableSortLabel-icon, .MuiTableSortLabel-root': { color: white, opacity: 1 }, } }}
                                        enableColumnActions={false}
                                        //enableColumnFilters={true}
                                        enableRowSelection={(isSupport) ? false : true}
                                        // enableMultiRowSelection={false}
                                        enableSelectAll={false}
                                        enableRowActions
                                        positionPagination="bottom"
                                        enableToolbarInternalActions={false}
                                        initialState={{
                                            density: 'compact',
                                            showColumnFilters: true,
                                            boxShadow: 'none',
                                            pagination: { pageSize: 10, pageIndex: 0, pageCount: -1, },
                                        }}
                                        positionActionsColumn="last"
                                        muiTablePaginationProps={{
                                            rowsPerPageOptions: [3, 5, 10, 15, 20],
                                            sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, }, }
                                        }}

                                        // onRowSelectionChange={handleRowSelectionChange} 
                                        // state={{ rowSelection }}

                                        renderTopToolbar={({ table }) => {
                                            const handleDeleteMultiple = () => {
                                                handleDeleteRow();
                                                table.getSelectedRowModel().flatRows.map((row) => {

                                                    //console.log("selectedOriginal", row);
                                                    setSelectedUsers(current => [...current, row.original]);

                                                });
                                            };

                                            return (
                                                <>
                                                    {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ?
                                                        (<div style={{ backgroundColor: primary.main }}>

                                                            <Button
                                                                color="secondary"
                                                                disabled={table.getSelectedRowModel().flatRows.length > 1 || table.getSelectedRowModel().flatRows.length === 0}
                                                                onClick={handleDeleteMultiple}
                                                                variant="contained"
                                                                size="small"
                                                                sx={{ mr: 1, ml: 1, mb: 1 }}
                                                            >
                                                                Delete User
                                                            </Button>
                                                            <Button onClick={resetMyFilters} mr={2} variant="contained"
                                                                sx={{
                                                                    '&:hover': {
                                                                        backgroundColor: secondary.main,
                                                                    }, mb: 1,
                                                                }} color="secondary" size="small" startIcon={<RefreshIcon sx={{ backgroundColor: secondary.main }} size="small" />}>
                                                                Reset Filters
                                                            </Button>

                                                        </div>) : (<></>)
                                                    }
                                                </>
                                            );
                                        }}
                                        renderRowActions={({ row }) => (
                                            <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '0.5rem' }}>
                                                {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ?
                                                    (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                                                        <Tooltip title="Reset password" aria-label="Reset password">
                                                            <IconButton sx={{
                                                                border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                                                                '&:hover': {
                                                                    backgroundColor: secondary.main,
                                                                },
                                                            }} color="text" size="small"
                                                                onClick={() => {
                                                                    handlePasswordOpenForm(row.original)
                                                                }}
                                                            >
                                                                <LockResetIcon style={{ backgroundColor: secondary.main }} size="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;
                                                        <Tooltip title="Edit" aria-label="View Monitor User">
                                                            <IconButton sx={{
                                                                border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main,
                                                                width: 30, height: 30,
                                                                '&:hover': {
                                                                    backgroundColor: secondary.main,
                                                                },
                                                            }} color="text" size="small"
                                                                onClick={() => {
                                                                    handleUpdateOpen(row.original)
                                                                }}
                                                            >
                                                                <EditIcon style={{ backgroundColor: secondary.main }} size="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </ButtonGroup>
                                                    ) :
                                                    (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                                                        <Tooltip title="View" aria-label="Apply">
                                                            <IconButton sx={{
                                                                border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                                                                '&:hover': {
                                                                    backgroundColor: secondary.main,
                                                                },
                                                            }} color="text" size="small"
                                                                onClick={() => {
                                                                    handleViewMonUserDetail(row.original)
                                                                }}
                                                            >
                                                                <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </ButtonGroup>
                                                    )
                                                }


                                            </div>
                                        )}

                                        filterFns={{
                                            emailFilterFn: (row, _columnIds, filterValue) => {
                                                if (filterValue !== null) {
                                                    if (filterValue !== 'All') {
                                                        return row.getValue('email') === filterValue;
                                                    } else {
                                                        return true;
                                                    }
                                                } else {
                                                    return true;
                                                }
                                            },
                                            firstNameFilterFn: (row, _columnIds, filterValue) => {
                                                if (filterValue !== null) {
                                                    if (filterValue !== 'All') {
                                                        return String(row.getValue('first_name')) === filterValue;
                                                    } else {
                                                        return true;
                                                    }
                                                } else {
                                                    return true;
                                                }
                                            },
                                            lastNameFilterFn: (row, _columnIds, filterValue) => {
                                                if (filterValue !== null) {
                                                    if (filterValue !== 'All') {
                                                        return row.getValue('last_name') === filterValue;
                                                    } else {
                                                        return true;
                                                    }
                                                } else {
                                                    return true;
                                                }
                                            },
                                            roleNameFilterFn: (row, _columnIds, filterValue) => {
                                                if (filterValue !== null) {
                                                    if (filterValue !== 'All') {
                                                        return row.getValue('role_name') === filterValue;
                                                    } else {
                                                        return true;
                                                    }
                                                } else {
                                                    return true;
                                                }
                                            },


                                        }}
                                    />


                                    <Dialog
                                        open={openDialog}
                                        onClose={handleUpdateCloseDialog}
                                        fullScreen={fullScreen}
                                        aria-labelledby="scroll-dialog-title"
                                        aria-describedby="scroll-dialog-description"
                                        sx={{
                                            '& .MuiDialog-paper': {
                                                backgroundColor: primary.main,
                                            }
                                        }}
                                    >
                                        <DialogTitle>
                                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                                                {'Edit Monitoring User Details'}
                                            </Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            <Grid container spacing={2} direction="row">
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>First Name</Typography>
                                                    <TextField
                                                        id='txtFldUsrFName'
                                                        name='usrFName'
                                                        placeholder='First Name'
                                                        value={usrFName || ''}
                                                        onChange={handleTxtFldChange}
                                                        sx={{
                                                            width: 220,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}
                                                    />

                                                </Grid>

                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Last Name</Typography>
                                                    <TextField
                                                        id='txtFldUsrLName'
                                                        name='usrLName'
                                                        placeholder='Last Name'
                                                        value={usrLName || ''}
                                                        onChange={handleTxtFldChange}
                                                        focused={false}
                                                        sx={{
                                                            width: 220,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>User Email</Typography>

                                                    <TextField
                                                        id="txtFldUsrEmail"
                                                        name="usrEmail"
                                                        placeholder="Email Address"
                                                        value={selectedRow ? (selectedRow.email !== null ? selectedRow.email : '') : ''}
                                                        focused={false}
                                                        disabled={true}
                                                        sx={{
                                                            width: 220,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}


                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '0px' }}>
                                                        Phone Number
                                                    </Typography>
                                                    <PhoneInput
                                                        id={`txtFldUsrPhoneNumber`}
                                                        name="usrPhoneNumber"
                                                        value={usrPhoneNumber || ''}
                                                        onChange={handlePhoneChange}
                                                        dropdownStyle={{ margin: '0px', backgroundColor: "primary.focus" }}
                                                        country={'us'}
                                                        autoComplete="off"
                                                        InputProps={{ readOnly: false, sx: { color: text.main } }}
                                                        specialLabel=''
                                                        sx={{
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            borderRadius: borderRadius.md
                                                        }}
                                                        placeholder="Enter phone number"
                                                        inputStyle={{ width: '80%', height: '45px', backgroundColor: '#EFEFEF', color: text.main, }}
                                                    />
                                                </Grid>


                                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Role Name</Typography>
                                                    <Select
                                                        fullWidth
                                                        sx={{ width: 220 }}
                                                        name="usrRoleName"
                                                        value={roleName || ''}
                                                        onChange={handleTxtFldChange}
                                                    >
                                                        {userRoleList.map((item) => (
                                                            <MenuItem
                                                                key={item.id}
                                                                value={toPascalCase(item.role)}
                                                            >
                                                                {toPascalCase(item.role)}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                                                        &nbsp; &nbsp;
                                                    </Typography>
                                                    <Grid item container direction="row" alignItems="center"  >
                                                        <Grid item sx={{ width: '50%' }}>
                                                            <Typography
                                                                variant="body2"
                                                                fontSize={size.md}
                                                                justifyContent="center"
                                                                color={text.main}
                                                                sx={{ fontWeight: 400, mb: 1 }}>
                                                                {`Mosaic View ${(enabledMosaicView) ? 'Enable ' : 'Disable'}`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Switch
                                                                name='chkUsrMosaicView'
                                                                checked={enabledMosaicView}
                                                                onChange={handleTxtFldChange}
                                                                sx={{ mb: 1 }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Grid item container direction="row" alignItems="center"  >
                                                        <Grid item sx={{ width: '50%' }}>
                                                            <Typography
                                                                variant="body2"
                                                                fontSize={size.md}
                                                                justifyContent="center"
                                                                color={text.main}
                                                                sx={{ fontWeight: 400, mb: 1 }}>
                                                                {`Preset Switch ${(enabledIOMatrixSwitch) ? 'Enable ' : 'Disable'}`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Switch
                                                                name='chkUsrIOMatrixSwitch'
                                                                checked={enabledIOMatrixSwitch}
                                                                onChange={handleTxtFldChange}
                                                                sx={{ mb: 1 }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                </Grid>


                                            </Grid>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleUpdateCloseDialog} color="secondary" variant="contained">
                                                Cancel
                                            </Button>
                                            <Button onClick={handleUpdateOpenConfirmation} color="secondary" disabled={!enableSaveBtn} variant="contained" >
                                                Save
                                            </Button>
                                        </DialogActions>
                                    </Dialog>

                                    <Dialog
                                        open={openConfirmationDialog}
                                        onClose={handleUpdateCloseConfirmation}
                                        fullScreen={fullScreen}
                                        aria-labelledby="scroll-dialog-title"
                                        aria-describedby="scroll-dialog-description"
                                        sx={{
                                            '& .MuiDialog-paper': {
                                                backgroundColor: primary.main,
                                            }
                                        }}
                                    >
                                        <DialogTitle>
                                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                                                {'Confirmation'}
                                            </Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            Are you sure you want to save the changes?
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleUpdateCloseConfirmation} color="secondary" variant="contained">
                                                No
                                            </Button>
                                            <Button onClick={handleSave} color="secondary" variant="contained" >
                                                Yes
                                            </Button>
                                        </DialogActions>
                                    </Dialog>

                                    <Dialog
                                        open={openViewDialog}
                                        onClose={handleCloseViewCustomerDialog}
                                        fullScreen={fullScreen}
                                        aria-labelledby="scroll-dialog-title"
                                        aria-describedby="scroll-dialog-description"
                                        sx={{
                                            '& .MuiDialog-paper': {
                                                backgroundColor: primary.main,
                                            }
                                        }}
                                    >
                                        <DialogTitle>
                                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                                                {'View Monitoring User Details'}
                                            </Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            <Grid container spacing={2} direction="row">

                                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>First Name</Typography>
                                                    <TextField
                                                        id='txtFldUsrFName'
                                                        name='usrFName'
                                                        placeholder='First Name'
                                                        value={selectedRow ? (selectedRow.first_name !== null ? selectedRow.first_name : '') : ''}
                                                        focused={false}
                                                        disabled={true}
                                                        sx={{
                                                            width: 200,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}
                                                    />

                                                </Grid>

                                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Last Name</Typography>
                                                    <TextField
                                                        id='txtFldUsrLName'
                                                        name='usrLName'
                                                        placeholder='Last Name'
                                                        value={selectedRow ? (selectedRow.last_name !== null ? selectedRow.last_name : '') : ''}
                                                        focused={false}
                                                        disabled={true}
                                                        sx={{
                                                            width: 200,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>User Email</Typography>
                                                    <TextField
                                                        id="email"
                                                        name="email"
                                                        placeholder="User Email"
                                                        value={selectedRow ? (selectedRow.email !== null ? selectedRow.email : '') : ''}
                                                        focused={false}
                                                        disabled={true}
                                                        sx={{
                                                            width: 200,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Role Name</Typography>
                                                    <TextField
                                                        id="role_name"
                                                        name="role_name"
                                                        placeholder="Role Name"
                                                        value={selectedRow ? (selectedRow.role_name !== null ? selectedRow.role_name : '') : ''}
                                                        focused={false}
                                                        disabled={true}
                                                        sx={{
                                                            width: 200,
                                                            color: text.main,
                                                            borderColor: primary.focus,
                                                            backgroundColor: transparent.main,
                                                            borderRadius: borderRadius.md,
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                                                        &nbsp; &nbsp;
                                                    </Typography>
                                                    <Grid item container direction="row" alignItems="center"  >
                                                        <Grid item sx={{ width: '50%' }}>
                                                            <Typography
                                                                variant="body2"
                                                                fontSize={size.md}
                                                                justifyContent="center"
                                                                color={text.main}
                                                                sx={{ fontWeight: 400, mb: 1 }}>
                                                                {`Mosaic View ${(selectedRow && selectedRow.mosaic_view_enabled) ? 'Enable ' : 'Disable'}`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Switch
                                                                checked={(selectedRow && selectedRow.mosaic_view_enabled)}
                                                                sx={{ mb: 1 }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                disabled={true}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Grid item container direction="row" alignItems="center">
                                                        <Grid item sx={{ width: '50%' }}>
                                                            <Typography
                                                                variant="body2"
                                                                fontSize={size.md}
                                                                justifyContent="center"
                                                                color={text.main}
                                                                sx={{ fontWeight: 400, mb: 1 }}>
                                                                {`Preset Switch ${(selectedRow && selectedRow.iomatrix_switch_enabled) ? 'Enable ' : 'Disable'}`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Switch
                                                                checked={(selectedRow && selectedRow.iomatrix_switch_enabled)}
                                                                sx={{ mb: 1 }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                disabled={true}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseViewCustomerDialog} color="secondary" variant="contained">
                                                Close
                                            </Button>
                                        </DialogActions>
                                    </Dialog>


                                    <Dialog
                                        open={openResetPassword}
                                        onClose={handlePasswordCloseForm}
                                        fullScreen={fullScreen}
                                        aria-labelledby="scroll-dialog-title"
                                        aria-describedby="scroll-dialog-description"
                                        sx={{
                                            '& .MuiDialog-paper': {
                                                backgroundColor: primary.main,
                                            }
                                        }}
                                    >
                                        <DialogTitle>
                                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                                                {'Reset Password'}
                                            </Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            <MonitorUserResetPassword
                                                bizUsrInfo={userInfo}
                                                selectedCustomer={selectedCustomer}
                                                UserReset={false}
                                                handleCloseForm={handlePasswordCloseForm}
                                                inProcess={inProcess}
                                            ></MonitorUserResetPassword>
                                        </DialogContent>
                                    </Dialog>


                                    <Dialog open={confirmDeleteOpen} onClose={handleConfirmClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth='md'
                                        sx={{
                                            '& .MuiDialog-paper': {
                                                backgroundColor: primary.main,
                                            }
                                        }}
                                    >
                                        <DialogTitle id="alert-dialog-title">
                                            <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{deleteMessageConfirmTitle}</Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">{deleteMessageConfirm}</DialogContentText>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
                                                onClick={handleDeleteNo}>No</Button>

                                            <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
                                                onClick={handleDeleteYes} autoFocus>Yes</Button>
                                        </DialogActions>
                                    </Dialog>
                                    <Snackbar
                                        anchorOrigin={{ vertical, horizontal }}
                                        open={showDeleteAlert}
                                        autoHideDuration={6000}
                                        key={vertical + horizontal}
                                        onClose={handleDeleteAlertClose}
                                    >
                                        <Alert elevation={6} variant="filled" onClose={handleDeleteAlertClose}
                                            severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message": { color: white.main, fontSize: size.sm }, marginBottom: 4 }}
                                        >
                                            {deleteAlertMsg}
                                        </Alert>
                                    </Snackbar>



                                </div>)

                                :

                                (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '10px' }}>
                                    <Typography variant="body2" color={text.main} sx={{ fontWeight: 600, }}>
                                        No Customer found
                                    </Typography>
                                </Box>)

                            }
                        </Grid>
                    </Grid>

                    {selectedCustomer.customer_id > 0 && (
                        <MonitorUserTableDialog
                            formData={selectedCustomer}
                            open={openAddUserDialog}
                            handleClose={handleAddUserCloseDialog}
                            userRoleList={userRoleList}
                        />
                    )
                    }
                </Box>
            </Box>
        </>
    )
}
